import * as Immutable from 'seamless-immutable';
import { OPEN_IFRAME, CLOSE_IFRAME } from '../actions';

const initialState = Immutable.from({
  url: null,
  title: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_IFRAME: {
      const { url, title } = action.payload;
      return state.merge({
        url,
        title,
      });
    }
    case CLOSE_IFRAME: {
      return state.merge({
        url: null,
        title: null,
      });
    }
    default:
      return state;
  }
};
